import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { useSite } from "@/contexts/SiteContext";
import { RenderIcon } from "@/components/admin/IconPicker";

export default function Techniques() {
  const { sectionContent } = useSite();
  const c = sectionContent("techniques");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/public/techniques").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!c) return null;

  return (
    <section data-testid="techniques-section" className="py-24 lg:py-32" style={{ background: "var(--ct-surface-2)" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Tehnici"}</span>
            <span className="gold-rule" />
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-4xl sm:text-5xl leading-tight">{c.title || "Tehnicile cu care lucrez"}</h2>
          {c.subtitle && <p data-el="subtitle" data-field="subtitle" className="text-base leading-relaxed mt-4" style={{ color: "var(--ct-text-muted)" }}>{c.subtitle}</p>}
        </div>

        {items.length > 0 && (
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {items.map((t, i) => (
                <Link
                  key={t.id}
                  to={`/tehnici/${t.slug}`}
                  className="card-premium p-7 flex flex-col h-full text-left"
                  data-testid={`technique-card-${i}`}
                >
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center mb-5"
                    style={{ background: "var(--ct-emerald)", border: "1.5px solid var(--ct-gold)" }}
                  >
                    <RenderIcon value={t.icon} size={20} color="var(--ct-gold)" />
                  </div>
                  <h3 className="font-serif text-2xl mb-2 leading-tight">{t.name}</h3>
                  <p className="text-sm leading-relaxed flex-1" style={{ color: "var(--ct-text-muted)" }}>{t.summary}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium" style={{ color: "var(--ct-link)" }}>
                    {t.home_cta_label || "Află mai mult"} <ChevronRight size={14} />
                  </span>
                </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
